import { Injectable } from "@angular/core";
import { SearchBoxComponentService } from "@spartacus/storefront";

@Injectable({
    providedIn: 'root',
  })
  export class UigSearchBoxComponentService extends SearchBoxComponentService {

    launchSearchPage(query: string): void {
        this.routingService.go({
          cxRoute: 'search',
          params: { query },
        });
      }
  }